import { makeStyles } from '@mui/styles'
import {
  ALICE_BLUE,
  CHARCOAL,
  ERROR,
  GREY_CHATEAU,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  WHITE,
  YELLOW_SEA,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

import { POPPINS } from '../../constants/styles/fonts'

const useStyles = makeStyles(() => ({
  detailsRow: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  detailsSubRow: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  inputHead: {
    flexShrink: 0,
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    width: '30%',
    marginRight: 10,
    color: CHARCOAL,
  },
  input: {
    '& > div': {
      borderColor: 'transparent',
      '& > input': {
        fontFamily: URBANIST,
        color: MIDNIGHT_EXPRESS,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '160%',
      },
    },
  },
  warningAddress: {
    width: '100%',
    flexShrink: 0,
    fontFamily: POPPINS,
    fontSize: 14,
    lineHeight: '160%',
    color: YELLOW_SEA,
    padding: '3px 14px 0px 14px',
  },
  addressesDropdown: {
    width: '100%',
  },
  newAddressDropdown: {
    zIndex: 3,
    backgroundColor: '#FFFFFF',
    padding: '10px 30px',
    '& > div': {
      maxWidth: '100%',
    },
    '& input': {
      padding: '7px 20px',
    },
  },
  submitError: {
    paddingTop: 10,
    fontFamily: POPPINS,
    fontSize: 14,
    color: ERROR,
  },
  modalButtons: {
    display: 'flex',
    marginTop: '30px',
  },
  modalCancelButton: {
    minWidth: '150px',
  },
  modalSaveButton: {
    width: '100%',
  },
  paperList: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 305,
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: POPPINS,
    color: NEON_BLUE_LIGHT,
    fontSize: 14,
    lineHeight: '150%',
    marginBottom: 10,
    cursor: 'pointer',
    alignSelf: 'flex-end',
    marginRight: 10,
    '& svg': {
      marginRight: 6,
      marginBottom: 1,
    },
  },
  disabled: {
    width: '100%',
    pointerEvents: 'none',
  },
  disableAddressDropdown: {
    pointerEvents: 'none',
    cursor: 'not-allowed',
    '&>div': {
      background: ALICE_BLUE,
    },
  },
  autocompleteAddress: {
    width: '100%',
    flexShrink: 0,
    fontFamily: POPPINS,
    fontSize: 14,
    lineHeight: '160%',
    color: GREY_CHATEAU,
    padding: '3px 14px 0px 14px',
  },
  validateButtonContainer: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: 10,
  },
  button: {
    padding: '0 10px',
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    lineHeight: '140%',
    fontWeight: 700,
    height: 40,
    border: 'none',
    borderRadius: 4,

    '&:hover': {
      opacity: 0.8,
    },
  },
  cancelButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,

    '&:hover': {
      backgroundColor: MEDIUM_GRAY,
      border: 'none',
    },
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    color: WHITE,

    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
      border: 'none',
    },
  },
  spinner: {
    position: 'relative',
    minHeight: 300,
  },
  googleAutocomplete: {
    width: '100%',
  },
}))

export default useStyles
